import { createSlice } from '@reduxjs/toolkit';
import { WorkflowsFetchSuccessAction, WorkflowsState } from './workflows.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: WorkflowsState = {
  loading: false,
  error: undefined,
  workflows: [],
};

const { actReq, actReject, actResolve } = makeActionCreator<WorkflowsState>();

export const workflowsSlice = createSlice({
  name: 'workflows',
  initialState,
  reducers: {
    fetchWorkflows: actReq(),
    fetchWorkflowsSuccess:
      actResolve<WorkflowsFetchSuccessAction['payload']>('workflows'),
    fetchWorkflowsFailure: actReject('error'),
  },
});

export const { fetchWorkflows, fetchWorkflowsSuccess, fetchWorkflowsFailure } =
  workflowsSlice.actions;

export const actions = {
  ...workflowsSlice.actions,
};

export const useWorkflowsSlice = createSliceHook(workflowsSlice.name, actions);
